import React, { useEffect, useMemo, useState } from 'react';
import { Card, Tabs } from 'antd';
import InstructionTypesPage from './InstructionTypes';
import StepLibraryPage from './StepLibrary';

const InstructionSystemPage: React.FC = () => {
  const storageKey = 'admin:instruction:activeTab';
  const [activeKey, setActiveKey] = useState<string>(() => {
    try {
      return sessionStorage.getItem(storageKey) || 'templates';
    } catch { return 'templates'; }
  });
  useEffect(() => {
    try { sessionStorage.setItem(storageKey, activeKey); } catch {}
  }, [activeKey]);

  return (
    <Card bodyStyle={{ padding: 12 }} headStyle={{ padding: '8px 12px' }} style={{ width: '100%' }}>
      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        items={[
          { key: 'templates', label: '指令模板列表', children: <InstructionTypesPage /> },
          { key: 'steplibrary', label: '仓库操作步骤库列表', children: <StepLibraryPage /> },
        ]}
      />
    </Card>
  );
};

export default InstructionSystemPage;


